<div 
    class="z-30 fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75"
    (click)="$event.preventDefault(); handleCloseTeam();"
>
    <div class="max-h-screen w-full flex flex-col items-center justify-center overflow-hidden">
        <div class="w-full max-w-screen-md flex flex-col my-6 p-8 gap-4 bg-white rounded-md shadow-lg overflow-hidden" (click)="$event.stopPropagation()">
            <div class="flex items-center justify-center gap-2 p-2 border-s-4 border-nside-orange-400 bg-orange-50 rounded-r-md">
                <div class="w-8 h-8">
                    <button 
                        class="w-8 h-8 flex items-center justify-center rounded-full bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 text-white shadow-custom-2"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-lightbulb">
                            <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
                            <path d="M9 18h6" />
                            <path d="M10 22h4" />
                        </svg>
                    </button>
                </div>
                <p class="text-xs">Assign users to the Behavioral Threat Assessment Team. It is recommended that at least three users be assigned to the team at all times. Remember** if a user is assigned to a Threat Assessment Team, they will have full access to complete and review the case.</p>
            </div>

            <div class="flex h-full overflow-y-auto">
                <div class="w-full flex flex-col overflow-hidden">
                    <div class="flex flex-row items-center justify-center gap-2 mb-4">
                        <h2 class="oswald-font text-3xl font-medium">USERS LIST</h2>
                    </div>
                    <div class="flex-grow overflow-y-auto pr-2">
                        <ng-container *ngIf="!loadingContacts">
                            <ng-container *ngIf="filteredContacts.length > 0; else emptyContact">                        
                                <div *ngFor="let contact of filteredContacts" class="flex flex-row items-center gap-2 mb-2">
                                    <div
                                        class="flex-grow px-2.5 py-1.5 flex items-center justify-between rounded-md bg-gray-50 h-10"
                                    >
                                        <span>{{ contact.name }}</span>
                                    </div>
                                    <button
                                        [disabled]="isContactSelected(contact)"
                                        class="w-10 h-10 flex items-center justify-center rounded-md border bg-gradient-to-b"
                                        [ngClass]="{
                                            'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': isContactSelected(contact),
                                            'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': !isContactSelected(contact)
                                            }"
                                        (click)="$event.preventDefault(); addContactToSelectedList(contact);"
                                    >
                                        <lucide-icon [name]="icons.Plus" [size]="20" class="text-white"></lucide-icon>
                                    </button>
                                </div>
                                
                            </ng-container>
                        </ng-container>                                 
                        <ng-template #emptyContact>
                            <div class="text-center text-nside-gray-100 italic">
                                Empty list
                            </div>
                        </ng-template>
                    </div>                
                </div>
                <div class="w-full flex flex-col overflow-hidden">
                    <h2 class="text-center oswald-font text-3xl mb-2">THREAT ASSESSMENT TEAM</h2>
                    <h2 class="text-center text-lg mb-4">for case {{ caseId }}</h2>
                    <div class="flex-grow overflow-y-auto">
                        <ng-container *ngIf="selectedContacts.length > 0; else emptySelectedContact">            
                            <div *ngFor="let selectedContact of selectedContacts" class="flex flex-row items-center gap-2 mb-2">
                                <div
                                    class="h-10 flex-grow px-2.5 py-1.5 flex items-center justify-between rounded-md bg-gray-50"
                                >
                                    {{ selectedContact.name }}
                                </div>
                                <button
                                    class="w-10 h-10 flex items-center justify-center rounded-md border border-nside-gray-100 bg-gradient-to-b from-nside-gray-100 to-nside-gray-200 hover:bg-gradient-to-b hover:from-nside-gray-300 hover:to-nside-gray-400"
                                    (click)="$event.preventDefault(); removeContactFromSelectedList(selectedContact);"
                                >
                                    <lucide-icon [name]="icons.X" [size]="20" class="text-white"></lucide-icon>
                                </button>
                            </div>
                        </ng-container>
                        <ng-template #emptySelectedContact>
                            <div class="text-center text-nside-gray-100 italic">
                                Assign users to team.
                            </div>
                        </ng-template>
                    </div>
                    <div class="mt-4 flex justify-end gap-2 oswald-font">
                        <button
                            class="py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                            (click)="$event.preventDefault(); handleCloseTeam();"
                        >
                            Close
                        </button>
                        <button 
                            class="py-1.5 w-20 shadow-custom-2 flex items-center justify-center text-white bg-gradient-to-b rounded-md"
                            [ngClass]="{
                                'from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': selectedContacts.length > 0,
                                'from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': selectedContacts.length < 1
                            }"
                            [disabled]="selectedContacts.length < 1"
                            (click)="saveSelectedUsers();"
                        >
                            Save
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<popup-message 
    [type]="messageModal"
    (close)="resetMessageModal()"
    [message]="popupMessage"
></popup-message>

<div *ngIf="loading">
    <spinner></spinner>
</div>